import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import HistoryIcon from 'assets/svg-icons/HistoryIcon';

import { Container, Wrapper, Label, Button } from './styles';

const ContainerWithHistory = ({ label, isOpened, setOpened, children }) => {
  const onClick = useCallback(() => setOpened(($) => !$), [setOpened]);

  return (
    <Container>
      <Wrapper>
        <Label>{label}</Label>
        <Button type="button" onClick={onClick}>
          <HistoryIcon isActive={isOpened} />
        </Button>
      </Wrapper>
      {children}
    </Container>
  );
};

ContainerWithHistory.propTypes = {
  label: PropTypes.string.isRequired,
  isOpened: PropTypes.bool.isRequired,
  setOpened: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default ContainerWithHistory;
